module.exports = __webpack_public_path__ + "static/media/Informativa_WeMi Servizi_TCB.19423e68.pdf";